import { Grid, Typography } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import React, { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import api from "_api";
import CustomTable from "components/TableExplanded/Table";
import useColumns from "./columns/mainColumns";
import useColumnsTwo from "./columns/subColumns";
import useProductData from "./data/data";
import CustomPagination from "components/TableExplanded/Pagination";
import Modal from "components/Modal/SuperAdmin/create/createPackage";
import ModalDelete from "components/Modal/SuperAdmin/delete/deletePackage";
import SearchBar from "components/TableExplanded/SearchBar";
import Swal from "sweetalert2";

const PackageManage = ({ className }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [selectedPackage, setSelectedPackage] = React.useState(null);
  const [isModalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [viewProduct, setViewProduct] = React.useState(null);
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState(""); // Store the search query

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedPackage && isModalOpen) setSelectedPackage(null);
  };
  const handleModalDeleteOpen = () => {
    setModalDeleteOpen(!isModalDeleteOpen);
    if (selectedPackage && isModalDeleteOpen) setSelectedPackage(null);
  };

  const [fetchData, setFetchData] = React.useState();

  const fetchProductData = async () => {
    try {
      const { data, isStatus } = await api.super_admin.getAllPackages();
      // console.log("data", data);
      if (isStatus) setFetchData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  React.useEffect(() => {
    fetchProductData();
  }, []);

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setSelectedPackage,
    handleModalOpen,
    handleModalDeleteOpen
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = React.useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            การจัดการแพคเกจ
          </Typography>
          {/* <DatePicker
            onChange={() => {
              console.log("hello");
            }}
          /> */}
          <GradientButton
            onClick={handleModalOpen}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>สร้างแพ็คเกจ</Typography>
            <AddCircleIcon fontSize="medium" />
          </GradientButton>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={filteredData.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )}
      />

      <CustomPagination
        count={filteredData.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedPackage={selectedPackage}
        fetchProductData={fetchProductData}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />

      <ModalDelete
        open={isModalDeleteOpen}
        onClose={handleModalDeleteOpen}
        data={selectedPackage}
        fetchProductData={fetchProductData}
        disableBackdropClick // Prevent clicking outside
        disableEscapeKeyDown // Prevent pressing `Esc`
      />
    </div>
  );
};
export default PackageManage;
